import { MarkedByEnum, PassageTypeEnum } from '@doltech/utils/lib/constants';
import { get, isNil } from 'lodash';
import { Instance, types as t } from 'mobx-state-tree';

import { ERROR_NEED_OVERRIDE } from '../../constants';
import { AnnotatedPassage } from '../../Passage/_implementations/annotated-passage.store';
import { RegularPassage } from '../../Passage/_implementations/regular-passage.store';
import { AbstractTestSection } from '../abstract-test-section.store';

export const ReadingTestSection = AbstractTestSection.named('ReadingTestSection')
  .props({
    currentViewMode: t.maybe(t.number),
    passageType: t.maybeNull(t.string),
    studentPassage: t.maybeNull(t.string),
    passage: t.maybeNull(
      t.union(
        {
          dispatcher: (s) => {
            if (s) {
              switch (s.type) {
                case PassageTypeEnum.ANNOTATE:
                  return AnnotatedPassage;
                case PassageTypeEnum.REGULAR:
                  return RegularPassage;
                default:
                  throw new Error(`Can't resolve passage type ${s.type}`);
              }
            }
            return RegularPassage;
          },
        },
        AnnotatedPassage,
        RegularPassage
      )
    ),
  })
  .views((self) => ({
    getPassage() {
      if (self.passage.getPassage) {
        return self.passage.getPassage();
      }
      throw new Error(ERROR_NEED_OVERRIDE);
    },

    getStudentPassage() {
      return self.studentPassage;
    },
    getSelectedPassage() {
      if (self.passage.getSelectedPassage) {
        return self.passage.getSelectedPassage();
      }
      throw new Error(ERROR_NEED_OVERRIDE);
    },
    getPassageParagraph({ explanation, isLocateExplanation }) {
      if (self.passage.getPassageParagraph) {
        return self.passage.getPassageParagraph({ explanation, isLocateExplanation });
      }
      throw new Error(ERROR_NEED_OVERRIDE);
    },

    get paragraphCount() {
      if (!isNil(self.passage.totalParagraphs)) {
        return self.passage.totalParagraphs;
      }
      throw new Error(ERROR_NEED_OVERRIDE);
    },

    getMarkedBy() {
      if (get(self, 'passage.markedBy')) {
        return get(self, 'passage.markedBy');
      }
      return MarkedByEnum.ALPHABET;
    },
  }))
  .actions((self) => ({
    updateCurrentViewMode(viewMode) {
      self.currentViewMode = viewMode;
    },
    setStudentPassage(studentPassage: string) {
      self.studentPassage = studentPassage;
    },
  }));

export interface ReadingTestSectionInstance extends Instance<typeof ReadingTestSection> {}
